import {DataType} from '@wix/editor-platform-ooi-metadata-resolver';
import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings';

export enum SettingsParamKeys {
  THANK_YOU_PAGE_TITLE = 'THANK_YOU_PAGE_TITLE',
  THANK_YOU_PAGE_TITLE_HTML_TAG = 'THANK_YOU_PAGE_TITLE_HTML_TAG',
  THANK_YOU_PAGE_SUBTITLE = 'THANK_YOU_PAGE_SUBTITLE',
  THANK_YOU_PAGE_SUBSCRIPTION_TITLE = 'THANK_YOU_PAGE_SUBSCRIPTION_TITLE',
  THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE = 'THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE',
  THANK_YOU_PAGE_ORDER_NUMBER_LABEL = 'THANK_YOU_PAGE_ORDER_NUMBER_LABEL',
  THANK_YOU_PAGE_TOTAL_COST_LABEL = 'THANK_YOU_PAGE_TOTAL_COST_LABEL',
  THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL = 'THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL',
  THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION = 'THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION',
  THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT = 'THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT',
  THANK_YOU_PAGE_BILLING_ADDRESS_LABEL = 'THANK_YOU_PAGE_BILLING_ADDRESS_LABEL',
  THANK_YOU_PAGE_PAYMENT_METHOD_LABEL = 'THANK_YOU_PAGE_PAYMENT_METHOD_LABEL',
}

export type ISettingsParams = {
  [SettingsParamKeys.THANK_YOU_PAGE_TITLE]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_TITLE_HTML_TAG]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_SUBTITLE]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_SUBSCRIPTION_TITLE]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_ORDER_NUMBER_LABEL]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_TOTAL_COST_LABEL]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT]: SettingsParamType.Object;
  [SettingsParamKeys.THANK_YOU_PAGE_BILLING_ADDRESS_LABEL]: SettingsParamType.String;
  [SettingsParamKeys.THANK_YOU_PAGE_PAYMENT_METHOD_LABEL]: SettingsParamType.String;
};

export default createSettingsParams<ISettingsParams>({
  [SettingsParamKeys.THANK_YOU_PAGE_TITLE]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_TITLE_HTML_TAG]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_SUBTITLE]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_SUBSCRIPTION_TITLE]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_ORDER_NUMBER_LABEL]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_TOTAL_COST_LABEL]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  [SettingsParamKeys.THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL]: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
    metadata: {
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: '',
      },
    },
  },
  THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.continueBrowsing.footerLink'),
    inheritFromAppScope: true,
    metadata: /* istanbul ignore next */ ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('thankYouPage.continueBrowsing.footerLink'),
      },
    }),
  },
  [SettingsParamKeys.THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT]: {
    type: SettingsParamType.Object,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  [SettingsParamKeys.THANK_YOU_PAGE_BILLING_ADDRESS_LABEL]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.billingInfo.label'),
    inheritFromAppScope: true,
    metadata: /* istanbul ignore next */ ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('thankYouPage.billingInfo.label'),
      },
    }),
  },
  [SettingsParamKeys.THANK_YOU_PAGE_PAYMENT_METHOD_LABEL]: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.paymentMethod.label'),
    inheritFromAppScope: true,

    metadata: /* istanbul ignore next */ ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('thankYouPage.paymentMethod.label'),
      },
    }),
  },
});
